export const convertDDToDMS = (decimalDeg: number, isLatitude: boolean): string => {
  const absD = Math.abs(decimalDeg);
  let d = Math.floor(absD);
  const mFloat = (absD - d) * 60;
  let m = Math.floor(mFloat);
  const sFloat = (mFloat - m) * 60;
  let s = Math.round(sFloat);

  // after rounding, the seconds might become 60
  if (s === 60) {
    m += 1;
    s = 0;
  }
  if (m === 60) {
    d += 1;
    m = 0;
  }

  let direction = '';

  if (isLatitude) {
    direction = decimalDeg < 0 ? 'S' : 'N';
  } else {
    direction = decimalDeg < 0 ? 'W' : 'E';
  }

  // perhaps a weird way to format DMS, but it's what the backend expects when importing
  return `${d} ${m} ${s} ${direction}`;
};
